var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiledir = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  fill: "none",
  viewBox: "0 0 20 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3CC451",
  d: "M6.86 6.111h13.146L16.005 15H2.858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0E7B8",
  d: "M13.433 3.889H5.144L0 13.333V0h5.716l2.858 2.222h4.859a.87.87 0 0 1 .606.244.822.822 0 0 1 0 1.178.87.87 0 0 1-.606.245"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v15H0z"
})))));
export { SvgFiledir as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4NF81MzI0KSI+CjxwYXRoIGQ9Ik02Ljg1OTE0IDYuMTExMDhIMjAuMDA2TDE2LjAwNDggMTVIMi44NTc5MUw2Ljg1OTE0IDYuMTExMDhaIiBmaWxsPSIjM0NDNDUxIi8+CjxwYXRoIGQ9Ik0xMy40MzI3IDMuODg4ODlINS4xNDQ0NEwwIDEzLjMzMzNWMEg1LjcxNjA0TDguNTc0MDYgMi4yMjIyMkgxMy40MzI3QzEzLjY2MDEgMi4yMjIyNSAxMy44NzgxIDIuMzEwMDYgMTQuMDM4OSAyLjQ2NjM0QzE0LjE5OTcgMi42MjI2MiAxNC4yOSAyLjgzNDU2IDE0LjI5IDMuMDU1NTZDMTQuMjkgMy4yNzY1NSAxNC4xOTk3IDMuNDg4NSAxNC4wMzg5IDMuNjQ0NzdDMTMuODc4MSAzLjgwMTA1IDEzLjY2MDEgMy44ODg4NiAxMy40MzI3IDMuODg4ODlaIiBmaWxsPSIjQjBFN0I4Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjg0XzUzMjQiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";